<template>
  <div class="user-component" style="padding:10px; padding-top:0px;">

    <va-inner-loading :loading="isLoadingData">
      <VaSkeletonGroup animation="wave" v-if="isLoadingData">
        <VaCard>
          <va-card-content style="display: inline-flex; align-items: center;">
            <VaSkeleton variant="circle" width="100px" height="100px" tag="div" />
          </va-card-content>
          <va-card-content style="display: flex; align-items: center;">
            <VaSkeleton variant="text" :lines="2" text-width="100%" tag="div" />
          </va-card-content>
        </VaCard>
      </VaSkeletonGroup>
      <va-card v-if="!isLoadingData" color="backgroundSecondary">
        <va-card-content>
          <div class="row">
            <div class="flex flex-col md12 sm12 xs12" style="text-align: center;">
              <div class="item">
                <img :src="userData.photo" style="width: 100px; border-radius: 100%;">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="flex flex-col md12 sm12 xs12" style="text-align: center;">
              <div class="item username">
                {{ userData.names }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="flex flex-col md12 sm12 xs12" style="text-align: center;">
              <div class="item username-detail">
                {{ userData.key }}
              </div>
            </div>
          </div>
        </va-card-content>
      </va-card>






      <h4 class="va-h4 username-detail" style="margin-bottom:0px;">
        {{ date }}
      </h4>

      <div class="row">
        <div class="flex flex'col m12 sm12 xs12">
          <va-button @click="confirmChecada()" :loading="isCheckin || isLoadingChecadas" class="mr-6 mb-2 mt-3"
            style="width:100%; margin-top:10px !important;" size="large" color="primary" gradient>

            <va-icon style="padding:0; margin:0px" square name="check" />Checar
          </va-button>
        </div>
      </div>


      <VaSkeleton v-if="isLoadingChecadas" height="2.3rem" style="margin-bottom:10px;" />
      <VaSkeleton v-if="isLoadingChecadas" height="2.3rem" style="margin-bottom:10px;" />
      <VaSkeleton v-if="isLoadingChecadas" height="2.3rem" style="margin-bottom:10px;" />
      <VaSkeleton v-if="isLoadingChecadas" height="2.3rem" style="margin-bottom:10px;" />



      <div v-if="!isLoadingChecadas">

        <va-list>

          <va-list-item style="margin-bottom: 10px !important;" v-for="(checada, index) in checadas" :key="index"
            class="list__item" color="primary" gradient>
            <va-list-item-section>
              <va-card color="primary" gradient>
                <va-card-content style="padding:10px;">
                  <va-list-item-section avatar>
                    <h2 style="text-align: justify; width:100%;"> <va-icon :name="checada.type" size="medium"
                        readonly></va-icon> {{ checada.time }}
                      <va-chip square size="small" style="float:right;">
                        {{ checada.note }}
                      </va-chip>
                    </h2>
                  </va-list-item-section>


                </va-card-content>
              </va-card>
            </va-list-item-section>

          </va-list-item>
        </va-list>




      </div>

      <va-modal v-model="modalConfirmar"
        message="Se va registrar la checada en este momento. Ésta acción no se puede deshacer." title="Confirmar"
        :mobile-fullscreen="false" ok-text="Confirmar" cancel-text="Cancelar" @ok="registrarChecada()" />
    </va-inner-loading>

  </div>
</template>

<script>
import { VaIcon, VaButton, VaCard, VaInnerLoading, VaCardContent, VaSkeleton, VaSkeletonGroup, VaModal, VaList, VaListItem, VaListItemSection, VaChip } from 'vuestic-ui'
import { ClientJS } from 'clientjs';
import { init as initPullToRefresh } from "js-pull-to-refresh"
import { useToast } from 'vuestic-ui'
const { init } = useToast()

export default {
  name: 'UserComponent',
  props: {
    token: String,
    isLoadingData: Boolean,
    userData: Object
  },
  components: {
    VaIcon, VaButton, VaCard, VaInnerLoading, VaCardContent, VaSkeleton, VaSkeletonGroup, VaModal, VaList, VaListItem, VaListItemSection, VaChip
  },
  data: function () {
    return {
      isCheckin: false,
      isLoadingChecadas: false,
      checadas: [
        { time: '11:22:05', type: 'location_on', note: 'Oficina Nogales' },
        { time: '12:22:05', type: 'credit_card', note: 'Tarjeta' },
        { time: '13:22:05', type: 'desktop_windows', note: 'Avante Web' },
        { time: '14:22:05', type: 'desktop_windows', note: 'Avante Web' },
      ],
      modalConfirmar: false,
      date: ''
    }
  },
  mounted() {

    var fecha = new Date();
    this.date = fecha.toISOString().slice(0, 10);
    this.getTodayInfo();

    initPullToRefresh({ onChangeToRefresh: this.getTodayInfo });

  },
  methods: {
    async getCurrenPosition() {
      const pos = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      return {
        lon: pos.coords.longitude,
        lat: pos.coords.latitude,
      };
    },
    async registrarChecada() {

      this.isLoadingChecadas = true;
      this.isCheckin = true;

      const client = new ClientJS();

      const location = await this.getCurrenPosition();

      const result = await fetch('https://gamasdeveloper.com/avanterh/api/registerChecada', {
      //const result = await fetch('http://avante.oorale.com/api/registerChecada', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        },
        body: JSON.stringify({
          fingerprint: client.getFingerprint(),
          device: client.getUserAgent(),
          location: location
        })
      });
      const response = await result.json();
      this.isCheckin = false;
      this.getTodayInfo();
      if (response.success) {
        if (response.status) {
          init({ title: 'Listo', message: response.message, color: 'success', duration: 5000, position: 'bottom-right', iconClass: 'done' });
        } else {
          init({ title: 'Error', message: response.message, color: 'danger', duration: 5000, position: 'bottom-right', iconClass: 'error' });
          if (response.reactivate) {
            this.$emit('needReactivate');
          }
        }
      }


    },
    confirmChecada() {
      this.modalConfirmar = true;



    },
    async getTodayInfo() {

      this.isLoadingChecadas = true;
      const client = new ClientJS();
      const result = await fetch('https://gamasdeveloper.com/avanterh/api/getTodayData', {
      //const result = await fetch('http://avante.oorale.com/api/getTodayData', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        },
        body: JSON.stringify({
          fingerprint: client.getFingerprint(),
          device: client.getUserAgent()
        })
      });
      const response = await result.json();
      if (response.success) {
        if (response.status) {
          this.date = response.date;
          this.checadas = response.checadas;
        } else {
          init({ title: 'Error', message: response.message, color: 'danger', duration: 5000, position: 'bottom-right', iconClass: 'error' });
          if (response.reactivate) {
            this.$emit('needReactivate');
          }

        }
      }

      this.isLoadingChecadas = false;

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-component {
  width: 100%;
  height: 55px;
  background-color: var(--primary-color);
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
}


.header-component img {
  height: 55px;
}

.username {
  font-size: 24px;
}


.username-detail {
  font-size: 16px;
  color: gray;
  font-weight: 400;
}
</style>
